export default class ArrayTools {
  static arraysEqual(a, b) {
    return a.every(item => b.includes(item)) && b.every(item => a.includes(item))
  }
}
